import type { StringTable } from './ru';

/** Uzbek (Latin). Uses ʻ (U+02BB) in oʻ/gʻ and ʼ (U+02BC) as tutuq belgisi. */
export const uz: StringTable = {
  'app.title': 'Koʻrish va linzalar simulyatori',
  'lang.ru': 'Русский',
  'lang.uz': 'Oʻzbekcha',
  'lang.en': 'English',

  'app.subtitle': 'Chapda — hozir qanday koʻrasiz, oʻngda — tanlangan davolashdan keyin qanday koʻrasiz.',
  'step.now': '1. Hozir qanday koʻrasiz',
  'step.after': '2. Davolash',
  'step.scene': 'Qayerda qaraymiz',
  'badge.now': 'Hozir, davolashsiz',
  'badge.after': 'Davolashdan keyin',
  'age': 'Yosh',
  'target': 'Linza sozlangan',
  'target.far': 'uzoqqa',
  'target.near': 'yaqinga',
  'gaze': 'Nigoh kursorga ergashadi',
  'zoom': 'Rasmni kattalashtirish',
  'tags': 'Masofa belgilari',
  'how': 'Bu qanday ishlaydi',
  'webgl.error': 'Simulyatsiya uchun WebGL2 qoʻllab-quvvatlaydigan brauzer kerak: Chrome, Edge, Firefox yoki Safari 16+.',
  'rendering': 'Tayyorlanmoqda…',
  'stage': 'Bosqich',
  'tag.far': '5 m',
  'tag.mid': '66 sm',
  'tag.near': '40 sm',
  'tag.m4': '4 m',
  'tag.m30': '30 m',
  'tag.m60': '60 m',
  'tag.cm75': '75 sm',
  'tag.cm45': '45 sm',
  'zoom.hint': 'Rasmni aylantiring',

  'treat.title': 'Davolash usuli',
  'treat.none': 'Davolashsiz',
  'treat.glasses': 'Koʻzoynak yoki yumshoq linzalar',
  'treat.glasses_aphakic': 'Afakiya koʻzoynagi',
  'treat.progressive': 'Progressiv koʻzoynak',
  'treat.progressive_aphakic': 'Afakiya uchun bifokal koʻzoynak',
  'treat.rgp': 'Qattiq kontakt linzalar',
  'treat.rgp_aphakic': 'Afakiya uchun kontakt linzalar',
  'treat.lasik': 'Lazer korreksiyasi',
  'treat.icl': 'Fakik linza (ICL)',
  'treat.iol': 'Gavharni almashtirish',
  'lens.title': 'Sunʼiy gavhar (IOL)',
  'lens.iol_mono': 'Monofokal',
  'lens.iol_monoplus': 'Monofokal+',
  'lens.iol_edof': 'EDOF',
  'lens.iol_tri': 'Trifokal',
  'version.title': 'Linza versiyasi',
  'version.plain': 'Oddiy',
  'version.toric': 'Torik — astigmatizmni tuzatadi',

  'refr.title': 'Refraksiya',
  'refr.hint': 'Koʻzoynak retseptidan yoki avtorefraktometr natijasidan. Silindrni plyus bilan ham kiritish mumkin.',
  'refr.se': 'Sferik ekvivalent {x}',
  'refr.meridians': 'meridianlar {m1} va {m2}',
  'refr.kind.emmetropia': 'emmetropiya',
  'refr.kind.myopia': 'miopiya',
  'refr.kind.hyperopia': 'gipermetropiya',
  'astig.simple_myopic': 'oddiy miopik astigmatizm',
  'astig.compound_myopic': 'murakkab miopik astigmatizm',
  'astig.simple_hyperopic': 'oddiy gipermetropik astigmatizm',
  'astig.compound_hyperopic': 'murakkab gipermetropik astigmatizm',
  'astig.mixed': 'aralash astigmatizm',

  'cond.title': 'Koʻz kasalliklari',
  'cond.aphakia': 'Afakiya (gavhar yoʻq)',
  'cond.aphakia.info': 'Gavharsiz koʻz: oʻz fokuslash qobiliyati yoʻq, SPH odatda taxminan +10…+12 D.',
  'cond.cataract': 'Katarakta',
  'cond.cataract.stages': ['boshlangʻich', 'yetilmagan', 'yetilgan', 'oʻta yetilgan'],
  'cond.kc': 'Keratokonus',
  'cond.kc.stages': ['I bosqich', 'II bosqich', 'III bosqich', 'IV bosqich'],
  'cond.glaucoma': 'Glaukoma',
  'cond.glaucoma.stages': ['boshlangʻich', 'rivojlangan', 'ancha rivojlangan', 'terminal'],
  'cond.amd': 'Yoshga bogʻliq makula degeneratsiyasi (YoMD)',
  'cond.amd.stages': ['erta', 'oraliq', 'kechki'],
  'cond.dr': 'Diabetik retinopatiya',
  'cond.dr.stages': ['noproliferativ', 'preproliferativ', 'proliferativ'],
  'cond.hr': 'Gipertonik retinopatiya',
  'cond.hr.stages': ['angiopatiya', 'angioskleroz', 'retinopatiya', 'neyroretinopatiya'],
  'cond.rp': 'Pigmentli retinit',
  'cond.rp.stages': ['boshlangʻich', 'oʻrtacha', 'rivojlangan', 'terminal'],
  'cond.amblyopia': 'Ambliopiya («dangasa koʻz»)',
  'cond.amblyopia.stages': ['juda yengil', 'yengil', 'oʻrta', 'yuqori', 'juda yuqori'],
  'cond.amblyopia.visus': ['Visus 0.8–0.9', 'Visus 0.4–0.7', 'Visus 0.2–0.3', 'Visus 0.05–0.1', 'Visus ≤ 0.04'],
  'cond.amblyopia.hint': 'Visus — shu darajada tuzatish bilan erishiladigan eng yaxshi oʻtkirlik; tuzatishsiz pastroq.',

  'corr.none.label': 'Tuzatishsiz',
  'corr.none.desc': 'Koʻz hozir qanday koʻradi.',
  'corr.glasses.label': 'Koʻzoynak / yumshoq linzalar (uzoq uchun)',
  'corr.glasses.desc': 'Miopiya, uzoqdan koʻrish va astigmatizmni tuzatadi. Taxminan 45 yoshdan keyin yaqin masofa oʻqish koʻzoynagisiz xira boʻladi.',
  'corr.glasses_aphakic.label': 'Afakiya koʻzoynagi',
  'corr.glasses_aphakic.desc': 'Qalin plyus linzalar (taxminan +10…+12 D): uzoq aniq koʻrinadi, oʻqish uchun qoʻshimcha kuch kerak. Narsalar taxminan chorak baravar kattaroq koʻrinadi, koʻrish maydoni torayadi, chetlarida buzilish boʻladi.',
  'corr.progressive.label': 'Progressiv koʻzoynak',
  'corr.progressive.desc': 'Linzaning yuqori qismi uzoq uchun, oʻrtasi ekran uchun, pasti oʻqish uchun.',
  'corr.progressive_aphakic.label': 'Afakiya uchun bifokal / progressiv koʻzoynak',
  'corr.progressive_aphakic.desc': 'Yuqorisi uzoq uchun, pasti toʻliq qoʻshimcha bilan (taxminan +3 D) oʻqish uchun: gavharsiz oʻz fokuslash yoʻq. Kattalashtirish afakiya koʻzoynagi kabi.',
  'corr.rgp.label': 'Qattiq / skleral linzalar',
  'corr.rgp.desc': 'Keratokonusda notekis shox pardani tekislaydi; odatda eng yaxshi aniqlikni beradi.',
  'corr.rgp_aphakic.label': 'Afakiya uchun kontakt linzalar',
  'corr.rgp_aphakic.desc': 'Linza shox parda ustida turadi: tasvir kamroq kattalashadi (taxminan 8 %), koʻrish maydoni afakiya koʻzoynagidagidan kengroq.',
  'corr.lasik.label': 'Lazer korreksiyasi (LASIK / SMILE)',
  'corr.lasik.desc': 'Shox parda shaklini oʻzgartiradi. Kechasi nur atrofida halqalar boʻlishi mumkin. Yoshga bogʻliq uzoqdan koʻrishni bartaraf etmaydi.',
  'corr.icl.label': 'Fakik linza (ICL)',
  'corr.icl.desc': 'Oʻz gavharingiz oldiga joylashtiriladi; fokuslash qobiliyati saqlanadi. Koʻpincha yuqori miopiyada qoʻllanadi.',
  'corr.iol_mono.label': 'IOL monofokal',
  'corr.iol_mono.desc': 'Bitta masofada aniq (odatda uzoqda). Oʻqish uchun koʻzoynak kerak boʻladi. Halqalar juda kam.',
  'corr.iol_monoplus.label': 'IOL monofokal+ (yaxshilangan)',
  'corr.iol_monoplus.desc': 'Oʻrta masofada aniqlikni biroz kengaytiradi; halqalar monofokal kabi.',
  'corr.iol_edof.label': 'IOL EDOF (kengaytirilgan fokus chuqurligi)',
  'corr.iol_edof.desc': 'Uzoq va oʻrta masofa koʻzoynaksiz; mayda matn uchun baʼzan koʻzoynak kerak. Halqalar kichik.',
  'corr.iol_tri.label': 'IOL trifokal (multifokal)',
  'corr.iol_tri.desc': 'Uzoq, oʻrta masofa va oʻqish koʻzoynaksiz. Yorugʻlik fokuslar orasida boʻlinadi: kontrast pasayadi, kechasi faralar atrofida halqalar.',
  'corr.icl_toric.label': 'Fakik linza (ICL) torik',
  'corr.iol_mono_toric.label': 'IOL monofokal torik',
  'corr.iol_monoplus_toric.label': 'IOL monofokal+ torik',
  'corr.iol_edof_toric.label': 'IOL EDOF torik',
  'corr.iol_tri_toric.label': 'IOL trifokal torik',
  'corr.toric.desc': 'Torik versiya astigmatizmni ham tuzatadi.',

  'w.kc_lasik': 'Keratokonusda lazer korreksiyasi odatda mumkin emas.',
  'w.high_lasik': '−8…−10 D dan kuchli miopiyada lazer odatda qoʻllanmaydi; koʻpincha ICL koʻrib chiqiladi.',
  'w.lasik_near': 'Miopiyani lazer bilan tuzatgandan keyin yosh oʻtgan sari yaqinni koʻzoynaksiz koʻrish yomonlashadi: oʻz miopiyangiz endi oʻqishga yordam bermaydi, presbiopiya esa qoladi.',
  'w.aphakia_lasik': 'Afakiyada lazer korreksiyasi odatda qoʻllanmaydi: uzoqdan koʻrish juda yuqori. IOL yoki kontakt linzalar koʻrib chiqiladi.',
  'w.cat_icl': 'Kataraktada ICL qoʻyilmaydi: odatda gavhar almashtiriladi.',
  'w.cat_glasses': 'Koʻzoynak va lazer gavhar xiralashishini yoʻqotmaydi.',
  'w.retina_multi': 'Multifokal va EDOF linzalar kontrastni pasaytiradi; YoMD, glaukoma, retinopatiya va pigmentli retinitda odatda tavsiya etilmaydi. Shifokor bilan maslahatlashing.',
  'w.astig_nontoric': 'Astigmatizm qoladi: linzalarning torik versiyalari bor.',
  'w.retina_any': 'Gavharni almashtirish va koʻzoynak toʻr parda va koʻruv nervini tiklamaydi.',
  'w.clear_lens_young': '40 yoshgacha tiniq gavharni almashtirish kamdan-kam qilinadi: oʻz fokuslash qobiliyati yoʻqoladi.',
  'w.amblyopia': 'Ambliopiyada («dangasa koʻz») tuzatish oʻtkirlikni faqat ambliopiya darajasi belgilagan chegaragacha oshiradi: koʻrish tizimi bolalikda rivojlanmagan. Davolash erta yoshda mumkin. Shifokor bilan maslahatlashing.',

  'n.aphakia': 'Afakiya — gavharsiz koʻz. Tuzatishsiz kuchli uzoqdan koʻrish boʻladi va yaqinga fokuslanmaydi. Afakiya koʻzoynagi narsalarni taxminan chorak baravar kattalashtiradi va koʻrish maydonini toraytiradi, kontakt linzalar kamroq kattalashtiradi; koʻpincha keyinroq IOL qoʻyiladi.',
  'n.rp_dark': 'Pigmentli retinitda yorugʻ xonadan qorongʻi xonaga oʻtganda koʻrish qiyin: koʻzlar qorongʻilikka sogʻlom koʻzdan ancha sekin va kamroq moslashadi. Rasmlar ostidagi «Yorugʻdan qorongʻiga» tugmasi buni sogʻlom koʻz bilan yonma-yon koʻrsatadi.',
  'n.hr': 'Gipertonik retinopatiya — yuqori qon bosimida toʻr parda tomirlarining oʻzgarishi. Dastlabki bosqichlarda koʻrish odatda oʻzgarmaydi, oʻzgarishlarni shifokor koʻz tubida koʻradi; keyinroq oʻchoqlar, shish va koʻrish pasayishi paydo boʻladi. Qon bosimini nazorat qilish muhim.',
  'n.dysphotopsia': 'Disfotopsiyalar — yorugʻlik effektlari boʻlishi mumkin: halqalar (chiroqlar atrofida yorugʻ doiralar), shuʼla va yaltirash, «yulduz» nurlar. Kechasi va keng qorachiqda kuchliroq, vaqt oʻtishi bilan odatda kamroq seziladi. «Tungi chiroqlar» sahnasi ularni yaqindan koʻrsatadi.',

  'demo.dark': '▶ Yorugʻdan qorongʻiga: qorongʻilikka moslashish',
  'demo.stop': '■ Koʻrsatishni toʻxtatish',
  'demo.caption': 'Yorugʻ xonadan qorongʻilikka · {x} daqiqa oʻtdi',
  'demo.left': 'Pigmentli retinitsiz',
  'demo.right': 'Pigmentli retinit bilan',

  'disclaimer': 'Faqat maʼlumot uchun. Bu tibbiy buyum emas va tashxis qoʻyish yoki davolashni tanlash uchun moʻljallanmagan. Haqiqiy koʻrish koʻz, miya, yorugʻlik va moslashuvga bogʻliq. Qarorni shifokoringiz bilan birga qabul qiling.',

  'how.items': [
    'Sahnadagi har bir narsa oʻz masofasida turadi: uzoqda, 66 sm yoki 40 sm. Har bir masofa uchun model nurlarni qorachiq orqali koʻz va tanlangan linza aberratsiyalarini hisobga olib kuzatadi va tasvirni qizil, yashil va koʻk yorugʻlik uchun alohida xiralashtiradi.',
    'Yosh fokuslash zaxirasini (presbiopiyani) va qorachiq oʻlchamini belgilaydi; sahnaning yorugʻligi ham qorachiqni oʻzgartiradi.',
    'Multifokal va EDOF linzalar yorugʻlikni fokuslar orasida boʻladi: fokuslanmagan qismi yorqin chiroqlar atrofida halqalar hosil qiladi. Koʻz ichidagi sochilish shuʼla beradi, gavhar va shox parda notekisliklari «yulduz» nurlar beradi. Ekran faralar kabi yorqin boʻlmaydi, shuning uchun tungi sahnalar yorqinlikni siqib koʻrsatiladi: halqalar va shuʼla koʻrinib turadi. «Tungi chiroqlar» sahnasi ularni yaqindan koʻrsatadi.',
    'Katarakta: yorugʻlik sochilishi (tuman, shuʼla), sargʻayish va notekis aberratsiyalar. Glaukoma, YoMD, diabetik va gipertonik retinopatiya, pigmentli retinit toʻr parda va nervga taʼsir qiladi; ular qora dogʻlar bilan emas, xiralik va «oʻchish» bilan koʻrsatiladi, chunki bemorlar buni shunday tasvirlaydi. Ambliopiya («dangasa koʻz»): optika joyida, lekin miya aniq koʻrishni oʻrganmagan; tuzatish olib tashlamaydigan xiralik sifatida koʻrsatiladi. Afakiya — gavharsiz koʻz: kuchli uzoqdan koʻrish va yaqinga fokus yoʻq.',
    'Bu soddalashtirish. Siz ekranga oʻz koʻzingiz bilan qaraysiz, miya yangi linzalarga haftalar davomida moslashadi, linzalar esa aniq modellar emas, umumiy turlar sifatida koʻrsatilgan. Koʻrish oʻtkirligi — modelning taxminiy bahosi.',
  ],

  'scene.chart': 'Sivtsev jadvali',
  'scene.home': 'Uy (oʻqish)',
  'scene.city_day': 'Shahar — kunduz',
  'scene.city_night': 'Shahar — tun',
  'scene.night_lights': 'Tungi chiroqlar (yaqindan)',

  'home.tv.title': 'OB-HAVO',
  'home.tv.cities': ['Toshkent +31°', 'Samarqand +29°', 'Buxoro +33°', 'Nukus +27°'],
  'home.tv.ticker': 'Ertaga quyoshli, shamol kuchsiz',
  'home.laptop.title': '40 yoshdan keyin koʻrishni qanday asrash mumkin',
  'home.laptop.body': [
    'Yaxshi koʻrsangiz ham, koʻzingizni yiliga bir marta tekshiring.',
    'Katarakta sekin va koʻpincha sezilmasdan rivojlanadi.',
    'Glaukoma dastlabki bosqichlarda ogʻritmaydi va bezovta qilmaydi.',
    'Ekran oldida ishlaganda tanaffus qiling.',
    'UV-filtrli quyosh koʻzoynagini taqing.',
    'Koʻrish toʻsatdan yomonlashsa, darhol shifokorga murojaat qiling.',
  ],
  'home.phone.msgs': [
    'Assalomu alaykum! Oftalmolog qabulini eslatamiz',
    'Ertaga, soat 10:00, 204-xona',
    'Rahmat, boraman!',
    'Iltimos, koʻzoynagingizni olib keling',
  ],
  'home.calendar': 'Sentabr 2026',
  'city.phone.turn': 'oʻngga buriling',
  'city.phone.eta': 'Yetib kelish 18:56 · 4 km',
  'chart.near': [
    'Yaxshi koʻrish',
    'kitob va xabarlarni',
    'ortiqcha zoʻriqishsiz',
    'oʻqishga yordam beradi.',
    'Dori qutisi va shartnomalardagi mayda yozuv',
    'yaqindan aniq koʻrishni talab qiladi.',
    '45 yoshdan keyin koʻpchilikka oʻqish koʻzoynagi',
    'yoki turli masofada fokus beradigan linzalar kerak.',
  ],
};
